var _classCallCheck = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var _require = require('orange-svg'),
  OrangeSVGPath = _require.OrangeSVGPath;

/**
 * Class implements sector of the circle (for pie-chart)
 */
var OrangeSVGCircularSector = /*#__PURE__*/function (_OrangeSVGPath) {
  "use strict";

  _inherits(OrangeSVGCircularSector, _OrangeSVGPath);
  var _super = _createSuper(OrangeSVGCircularSector);
  /**
   *
   * @param {number} start_value Percentage of the sector's beginning
   * @param {number} added_value Percentage of the circle for the sector
   * @param {number} radius Circle radius
   * @param {?string} color
   * @param {number=0} center_x Circle center X
   * @param {number=0} center_y Circle center Y
   */
  function OrangeSVGCircularSector(start_value, added_value, radius) {
    var color = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var center_x = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var center_y = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    _classCallCheck(this, OrangeSVGCircularSector);
    var sc = OrangeSVGCircularSector.calculateCoordinates(start_value, radius);
    sc[0] += center_x;
    sc[1] += center_y;
    var end_value = start_value + added_value;
    var cc = OrangeSVGCircularSector.calculateCoordinates(end_value, radius);
    cc[0] += center_x;
    cc[1] += center_y;
    var more_than_half = added_value > 0.5;
    return _super.call(this, "M ".concat(sc.join(' '), " A ").concat(radius, " ").concat(radius, " 0 ").concat(more_than_half ? 1 : 0, " 1 ").concat(cc.join(' '), " L ").concat(center_x, " ").concat(center_y), color);
  }
  _createClass(OrangeSVGCircularSector, null, [{
    key: "calculateCoordinates",
    value:
    /**
     * Calculates position of the dot on the circle's radius based on percentage
     *
     * @param {number} value Percent
     * @param {number} radius Circle radius
     * @return {[number, number]} x,y
     * @static
     */
    function calculateCoordinates(value, radius) {
      return [Math.cos(2 * Math.PI * value) * radius, Math.sin(2 * Math.PI * value) * radius];
    }
  }]);
  return OrangeSVGCircularSector;
}(OrangeSVGPath);
module.exports = OrangeSVGCircularSector;